import React from 'react';
import { Input, Button, Form, Typography } from 'antd';

export function ForgetPassoword({ onSubmit, disabled, toggleActiveTab }) {
  return (
    <>
      <Typography.Title level={3} style={{ textAlign: 'center' }}>Forget Passoword</Typography.Title>
      <Typography.Paragraph style={{ textAlign: 'center' }}>
        <span>Go back to</span>
        <Button type="link" onClick={toggleActiveTab}>Login</Button>
      </Typography.Paragraph>
      <Form
        name="login"
        onFinish={ onSubmit }
        layout="vertical"
        requiredMark={ false }
      >
        <Form.Item
          label="Email"
          name="email"
          rules={[
            { type: 'email', message: 'Not a valid email.' },
            { required: true, message: 'Please enter your email.' },
          ]}
        >
          <Input type="email" autoComplete="email" disabled={ disabled } />
        </Form.Item>
        <Form.Item>
          <div style={{ textAlign: 'center' }}>
            <Button type="primary" htmlType="submit" disabled={ disabled } style={{ minWidth: 190 }} size="large">Reset Passoword</Button>
          </div>
        </Form.Item>
      </Form>
    </>
  );
}
